
export function putArray(array, object, idName = "id"){
    let myArray = array.slice();
    if (!object) return myArray;
    let index = -1;

    if(typeof object === "object") //can be a simple data
        index = myArray.map(i => i.id).indexOf(object[idName]);
    else 
        index = myArray.indexOf(object);

    if(index === -1){
        myArray.push(object);
    } else {
        myArray[index] = object;
    }

    return myArray;
}

export function deleteObjectInArray(array, id) {
    return array.slice().filter(i => i.id !== id);
}


// WEBPACK FOOTER //
// ./src/helper/array.js